import ZoomPart from "./zoom_part";
import { store } from '../../store';
import { TOOLS } from "../toolbar/tools";
import { windowContentScaleX, windowContentScaleY } from '../common/content_scale';
import PainterProxy from '../painter/proxy';

export default class AFileZoomPart extends ZoomPart{
    afileWindow = null;

    constructor(bookPage) {
        super(bookPage);
        this.afileWindow = bookPage.$refs.aFileWindow;
    }

    onPointerDown(e) {
        console.log("start pointer down")
        this.startMove = true;
        let svgContainerBoundingRect = this.bookPage.afileContainer.getBoundingClientRect();
        this.bookPage.zoomLeft = (e.clientX - svgContainerBoundingRect.x) / windowContentScaleX.value;
        this.bookPage.zoomTop = (e.clientY - svgContainerBoundingRect.y) / windowContentScaleY.value;
    }

    onPointerMove(e) {
        if (!this.startMove) return;
        let svgContainerBoundingRect = this.bookPage.afileContainer.getBoundingClientRect();
        let width = (e.clientX - svgContainerBoundingRect.x) / windowContentScaleX.value - this.bookPage.zoomLeft;
        let height = (e.clientY - svgContainerBoundingRect.y) / windowContentScaleY.value - this.bookPage.zoomTop;

        this.bookPage.rotateX = (height > 0) ? "0" : "180";
        this.bookPage.rotateY = (width > 0) ? "0" : "180";
        this.bookPage.zoomWidth = Math.abs(width);
        this.bookPage.zoomHeight = Math.abs(height);
    }
    onPointerUp(e) {
        this.startMove = false;

        const proxy = PainterProxy.getInstance();

        proxy.getCurrentPainter().painter.isInteractive = true;

        let svgContainerBoundingRect = this.bookPage.svgContainer.getBoundingClientRect();
        let scaleW = svgContainerBoundingRect.width / windowContentScaleX.value / this.bookPage.zoomWidth;
        let scaleH = svgContainerBoundingRect.height / windowContentScaleY.value / this.bookPage.zoomHeight;

        let scale = Math.min(Math.min(scaleW, scaleH), 10);

        let targetPoint = {
            x: this.bookPage.zoomLeft + this.bookPage.zoomWidth * 0.5 * (this.bookPage.rotateY > 0 ? -1 : 1),
            y: this.bookPage.zoomTop + this.bookPage.zoomHeight * 0.5 * (this.bookPage.rotateX > 0 ? -1 : 1)
        }

        targetPoint.x = (targetPoint.x - this.bookPage.svgScaler.offsetLeft) * windowContentScaleX.value * windowContentScaleX.value;
        targetPoint.y = (targetPoint.y - this.bookPage.svgScaler.offsetTop) * windowContentScaleY.value * windowContentScaleY.value;

        this.bookPage.zoom(targetPoint.x, targetPoint.y, scale);

        this.bookPage.zoomLeft = 0;
        this.bookPage.zoomTop = 0;
        this.bookPage.zoomWidth = 0;
        this.bookPage.zoomHeight = 0;

        store.nowTool = TOOLS.SELECTION.TOOL;
    }
}